"use client"

import { useSyncExternalStore } from "react"

import { localeCookie, resolveLocale, translate, type Locale } from "@/i18n/locale"
import { TemporaryErrorScreen } from "@/components/system-status/temporary-error-screen"

import "@fontsource-variable/inter"
import "./globals.css"

const subscribeToNothing = () => () => {}

// The root layout and its locale/theme providers are replaced here, so read the
// presentation-only preferences in the browser; the server renders Turkish/light.
function readBrowserLocale(): Locale {
  const value = document.cookie.split("; ").find(entry => entry.startsWith(`${localeCookie}=`))?.slice(localeCookie.length + 1)
  return resolveLocale(value)
}

function readDarkTheme(): boolean {
  let theme: string | null = null
  try { theme = window.localStorage.getItem("qih-theme") } catch { /* storage unavailable */ }
  return theme === "dark" || (theme !== "light" && window.matchMedia("(prefers-color-scheme: dark)").matches)
}

export default function GlobalError({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const locale = useSyncExternalStore(subscribeToNothing, readBrowserLocale, () => "tr" as const)
  const dark = useSyncExternalStore(subscribeToNothing, readDarkTheme, () => false)
  return (
    <html lang={locale} className={dark ? "dark" : undefined}>
      <head>
        <title>{translate(locale, "Quibas Integration Hub - Geçici kesinti")}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </head>
      <body className="antialiased">
        <TemporaryErrorScreen locale={locale} reset={reset} />
      </body>
    </html>
  )
}
